var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "notifications") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.648l2.352 2.352v1.148h-18.703v-1.148l2.352-2.352v-5.797q0-2.734 1.395-4.758t3.855-2.625v-0.82q0-0.711 0.492-1.23t1.258-0.52 1.258 0.52 0.492 1.23v0.82q2.461 0.602 3.855 2.625t1.395 4.758v5.797zM14 25.648q-0.984 0-1.668-0.656t-0.684-1.641h4.703q0 0.93-0.711 1.613t-1.641 0.684z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.6b68b79692f1a9375c8c458c36dcd3f7.svg";
export { ForwardRef as ReactComponent };